import PARENT_SCOPE from '../types';

export const SCOPE = `${PARENT_SCOPE}.alertDiagnostics`;

export const INIT = `${SCOPE}/INIT`;

export const INIT_TEMP_DASHBOARD = `${SCOPE}/INIT_TEMP_DASHBOARD`;
export const START_FETCHING = `${SCOPE}/START_FETCHING`;
export const END_FETCHING = `${SCOPE}/END_FETCHING`;
